"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGridGapShorthand = exports.openGridGapShorthand = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getGridGapShorthandParts = function () {
    return [
        {
            prop: 'grid-row-gap',
            dataType: css_data_types_1.lengthPercentageDataType,
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['grid-row-gap', 'grid-column-gap']),
        },
        {
            prop: 'grid-column-gap',
            dataType: css_data_types_1.lengthPercentageDataType,
        },
    ];
};
// grid-gap
var openGridGapShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'grid-gap',
        parts: getGridGapShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openGridGapShorthand = openGridGapShorthand;
var closeGridGapShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getGridGapShorthandParts()));
};
exports.closeGridGapShorthand = closeGridGapShorthand;
//# sourceMappingURL=grid-gap-shorthand.js.map